import { __ } from '@wordpress/i18n';
import './ErrorNotice.css';

const ErrorNotice = ({ errors }) => {

    return (
        <section className='sb-error-notice sb-fs'>
            <div className='sb-feed-error'>
                <span>{__('This error message is only visible to WordPress admins.', 'sb-customizer')}</span>
                {
                    errors?.map((error, errorIndex) => {
                        return (
                            <div className='sb-error-notice-item' key={errorIndex}>
                                {error?.message && <p><strong>{error.message}</strong></p>}
                                {error?.directions && <p  dangerouslySetInnerHTML={{ __html: error?.directions }}></p>}

                            </div>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default ErrorNotice;